import UsersTable from "./UsersTable";
import "../../styles/users.css";

const UserManagement = () => {
	return (
		<>
			<div className="component-body">
				<div className="page-title">
					<h2>User Management</h2>
				</div>
				
				<div className="mt-3">
					<UsersTable/>
				</div>
			</div>
		</>
	)
}

export default UserManagement;